// @flow
import * as React from 'react';
import { useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ModalCloseButton } from '@coverright/ui/shared';
import { AgentForm } from '../../../features';

export const CreateAgentButton = ({onSubmit}: {onSubmit: () => void}) => {
  const [open, setOpen] = useState(false);



  return <>
    <Dialog fullWidth maxWidth={'sm'} open={open} onClose={() => setOpen(false)}>
      <DialogTitle variant={'h3'}>
        Create agent
        <ModalCloseButton onClick={() => setOpen(false)} sx={{position: 'absolute', top: 4, right: 8}} />
      </DialogTitle>
      <DialogContent>
        <AgentForm onSubmit={() => {
          setOpen(false)
          onSubmit();
        }} />
      </DialogContent>
    </Dialog>
    <Button variant={'contained'} size={'small'} sx={{minWidth: 150, alignSelf: 'center'}} onClick={e => {
      setOpen(true)
    }}>
      Create new agent
    </Button>
  </>
};
